var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"component-name"}},[_vm._v("\n  Hej, jag är en ny komponent.\n  "),_c('p',[_vm._v(_vm._s(this.$store.state.count))]),_vm._v(" "),_c('button',{on:{"click":_vm.increment}},[_vm._v("increment")]),_vm._v(" "),_c('button',{on:{"click":_vm.decrement}},[_vm._v("decrement")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cfd675fa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Empty.vue
// module id = null
// module chunks = 